import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pied-piper-pp': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zM257.9 241.6c17.4 0 31.7 17 31.7 38.1 0 20.9-14.3 37.8-31.7 37.8-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6s-33.2-79.6-74.2-79.6c-12 0-24.1 3.2-34.6 8.8h-45.7v206.3l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zM343.4 280.4c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4 0.2-9.6 0.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8v156.3l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pied-piper-pp.js
// module id = 968
// module chunks = 0